import {
  keyIsValid,
  keyStringsEncoded,
  keyHasCalledOnce,
  validHash,
  defaultHash,
  redirectHook
} from "#vuepal-build/trusted-origins";
import {
  useState,
  computed,
  watch,
  useNuxtApp
} from "#imports";
import { globalWindow, getStrings } from "./../../helpers/trustedOrigins.js";
export function useTrustedOrigin(options) {
  if (import.meta.server) {
    return computed(() => null);
  }
  const app = useNuxtApp();
  const status = useState(keyIsValid, () => defaultHash);
  const stringsEncoded = useState(
    keyStringsEncoded,
    () => null
  );
  const hasCalledOnce = useState(keyHasCalledOnce, () => false);
  function validate(stateVar, strings) {
    const _document = strings[0];
    const _location = strings[1];
    const _origin = strings[2];
    const _includes = strings[3];
    const errorMessage = strings[4];
    const separator = strings[5];
    const origins = strings[6].split(separator);
    let tmp = "";
    function checkOrigin() {
      if (globalWindow) {
        tmp = origins[_includes](globalWindow[_document][_location][_origin]) ? validHash : errorMessage;
      }
    }
    checkOrigin();
    stateVar.value = tmp;
  }
  if (!hasCalledOnce.value) {
    hasCalledOnce.value = true;
    if (globalWindow) {
      getStrings(stringsEncoded.value, (strings) => {
        const _setTimeout = strings[7];
        const _Math = strings[8];
        const _round = strings[9];
        const _random = strings[10];
        const m = globalWindow[_Math];
        const delayBase = parseInt(strings[11]);
        const delayMax = parseInt(strings[12]);
        const delay = delayBase + m[_round](m[_random]() * delayMax);
        globalWindow[_setTimeout](() => {
          validate(status, strings);
        }, delay);
      });
    } else {
      status.value = "Error";
    }
  }
  const result = computed(
    () => status.value === validHash || status.value === defaultHash ? null : status.value
  );
  const redirect = options?.redirect;
  if (redirect) {
    watch(
      result,
      () => {
        if (result.value === null) {
          return;
        }
        app.hooks.callHook(redirectHook);
      },
      {
        immediate: true
      }
    );
  }
  return result;
}
